<mat-icon *ngIf="Settings.isInAny(['Admin'], true)" (click)="trace()" style=" cursor: help; margin: 0px 0px; height: 12px; width: 12px; font-size: 12px; margin-top: -25px;">help</mat-icon>
